import classNames from 'classnames';
import React, { Component } from 'react';
import './OptionList.css';

// Props
// options: string[];
// savedOption: string;
// handleSelectOption: (option: string) => void;

export default class OptionList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOption: this.props.savedOption
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.savedOption !== this.props.savedOption) {
      this.setState({
        selectedOption: nextProps.savedOption
      });
    }
  }

  // option: string
  // e: React.MouseEvent<HTMLElement>
  onClickOption = (option, e) => {
    this.setState({
      selectedOption: option
    }, () => {
      this.props.handleSelectOption(this.state.selectedOption);
    });
  }

  render() {
    return (
      <div className={'OptionList'}>
        <div className={'OptionList-list'}>
          {this.props.options.map((option, index) => {
            const optionClass = classNames('OptionList-option', {
              'OptionList-option--selected': option === this.state.selectedOption
            });
            return (
              <div
                className={optionClass}
                key={index}
                onClick={this.onClickOption.bind(this, option)}
              >
                {option.toLocaleUpperCase()}
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}
